<template>
  <LoadingData v-if="loadData" />
  <div v-else class="card">
    <div class="card-header py-0">
      <h6 class="py-3 mb-0">Cargos que o Curso está Vinculado</h6>
    </div>
    <div v-if="roles.length > 0" class="table-responsive">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Descrição</th>
            <th class="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="role in roles" :key="role.id">
            <td>{{ role.name }}</td>
            <td>{{ role.description }}</td>
            <td class="text-center">
              <router-link
                :to="`/roles/${role.id}`"
                class="btn btn-outline-primary btn-icon rounded-pill ml-2"
                title="Visualizar Detalhes do Cargo"
              >
                <i class="ph-file-text" />
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="card-body text-center">
      <p>Este curso não está associado a nenhum cargo</p>
      <router-link
        :to="`/roles`"
        class="btn btn-outline-dark"
        title="Listagem de Cargos"
      >
        Listagem de Cargos
      </router-link>
    </div>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'

export default {
  name: 'RolesCourse',

  components: {
    LoadingData,
  },

  props: {
    courseId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      roles: {},
    }
  },

  methods: {
    async getRoles() {
      try {
        this.roles = await this.$store.dispatch('getRolesCourse', this.courseId)
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.getRoles()
  },
}
</script>
